import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { clamp } from 'es-toolkit';
import type { PropsWithClassName } from '../../../../../../types';
import {
  useAdjustOnScrollAndDrag,
  useIsOutOfViewport
} from '../../../../../helpers';
import type { DefaultButtonProps } from '../DefaultButton';
import { VolumeControlButton } from './VolumeControlButton';
import {
  VolumeControlSlider,
  VolumeControlSliderComponent
} from './VolumeControlSlider';
import { useVolume } from './VolumeProvider';

export function VolumeComponent({
  className,
  ...forwardingProps
}: PropsWithClassName<DefaultButtonProps>) {
  const containerRef = useRef<HTMLElement | null>(null);
  const { volume, setVolume, setSliderPosition } = useVolume();
  const { out, ref, containerRect, revalidate } = useIsOutOfViewport();

  useAdjustOnScrollAndDrag(containerRef, (delta) => {
    const next = clamp(volume + delta, 0, 1);
    setVolume(next);
  });

  useEffect(() => {
    setSliderPosition(out.top ? 'bottom' : 'top');
  }, [out, setSliderPosition]);

  return (
    <VolumeControlComponent
      className={className}
      ref={(element) => {
        containerRef.current = element;
        containerRect(element);
      }}
      onMouseOver={() => revalidate()}
    >
      <VolumeControlSlider ref={ref} />
      <VolumeControlButton {...forwardingProps} />
    </VolumeControlComponent>
  );
}

export const VolumeControlComponent = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover ${VolumeControlSliderComponent} {
    opacity: 1 !important;
    pointer-events: all;
  }
`;
